import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

const useOnePotential = (id) => {
  const [potential, setPotential] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getOnePotential(id) {
      try {
        const potential = await dataProvider.getOne("potentials", { id: id });
        setPotential(potential.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        return setError(error);
      }
    }

    setLoading(true);
    getOnePotential(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { potential, loading, error };
};

export default useOnePotential;
